import { useState, useEffect } from 'react'
import { useSurveyStore } from 'Store/Survey'
import Swal from 'sweetalert2'
import { shallow } from 'zustand/shallow'

export interface Props {
  selectedSurveyId: number | null
  isOpen: boolean
  handleClose: () => void
}

const ViewModel = (props: Props) => {
  const { selectedSurveyId, isOpen, handleClose } = props
  const { saleUsers, getAll, getOne, getSaleUsers, update } = useSurveyStore(
    state => ({
      selected: state.selected,
      saleUsers: state.saleUsers,
      getAll: state.getAll,
      getOne: state.getOne,
      getSaleUsers: state.getSaleUsers,
      update: state.edit,
    }),
    shallow
  )
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [selectedSaleUsers, setSelectedSaleUsers] = useState<any[]>([])

  const saleUserOptions = saleUsers.map(user => ({
    label: user.fullName,
    value: user.id,
  }))

  const fetchData = () => {
    if (selectedSurveyId && isOpen) {
      getOne(selectedSurveyId).then(res => {
        if (res.success) {
          setSelectedSaleUsers(
            (res.data?.survey.surveySaleUsers || []).map((su: any) => ({ id: su.userId })) || []
          )
        }
      })
    }
  }

  const onChangeSaleUsers = (selectedOptions: any) => {
    setSelectedSaleUsers(
      selectedOptions ? selectedOptions.map((option: any) => ({ id: option.value })) : []
    )
  }

  const onClose = () => {
    handleClose()
  }

  const onSubmit = () => {
    if (!selectedSurveyId) return

    setIsSubmitting(true)
    const body = {
      surveySaleUsers: selectedSaleUsers.map(su => ({
        userId: su.id,
      })),
    }

    update(selectedSurveyId, body).then(res => {
      setIsSubmitting(false)
      if (res.success) {
        onClose()
        getAll()
      } else {
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: res.data?.message || res?.data || 'ไม่สามารถอัพเดทข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
        })
      }
    })
  }

  useEffect(() => {
    getSaleUsers()
  }, [getSaleUsers])

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, selectedSurveyId])

  return {
    isOpen,
    isSubmitting,
    saleUserOptions,
    selectedSaleUsers,
    onClose,
    onChangeSaleUsers,
    onSubmit,
  }
}

export default ViewModel
